<template>
    <div class="card-container">
        <common-top-form :model="formModel" @openAddDialog="addInfo()" :submitService="submitService" addShowPower="/tatrauth/add" :submitData="submitData" @success="onSuccess">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatSimpleId" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chnId" label="通道名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tradingType" label="交易类型" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.tradingType == 1 ? '储蓄卡' : scope.row.tradingType == 2 ? '信用卡' : '--'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="feeType" label="计费类型" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.feeType == 1 ? '费率' : '笔'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="feeAmt" label="计费标准（元）" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.feeAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <!--<el-table-column prop="modifier" label="修改人"></el-table-column>-->
            <el-table-column prop="updateTime" label="修改时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.status == 0 ? '禁用' : '启用'}}</p>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="150" v-if="hasPerm('/tatrauth/edit') || hasPerm('/tatrauth/delete') || hasPerm('/tatrauth/udpStatus')">
                <template slot-scope="scope">
                    <el-button type="text" @click="updateInfo(scope.row.id)" v-if="hasPerm('/tatrauth/edit')">修改</el-button>
                    <el-button type="text" @click="DeleteInfo(scope.row.id)" class="button-color" v-if="hasPerm('/tatrauth/delete')">删除</el-button>
                    <el-button type="text" @click="Disabled(scope.row.id,scope.row.status)" class="button-color" v-if="hasPerm('/tatrauth/udpStatus')">
                        {{scope.row.status == 1 ? '禁用' : '启用'}}
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules"
                     @success="dialogSuccess" @close="dialogClose" @opend="dialogOpen" class="note">
            <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId" :needAll="false" selectWidth="100%"></select-organs>
            <el-form-item label="通道名称" prop="chnId">
                <!--<el-input v-model="dialogModel.chnId" placeholder="请输入通道名称"></el-input>-->
                <el-select v-model="dialogModel.chnId">
                    <el-option
                        v-for="item in chnNameList"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型" prop="tradingType">
                <!--<el-input v-model="dialogModel.chnId" placeholder="请输入通道名称"></el-input>-->
                <el-select v-model="dialogModel.tradingType">
                    <el-option
                        v-for="item in tradingTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计费方式" prop="feeType" v-if="authId">
                <el-select v-model="dialogModel.feeType" :disabled="true">
                    <el-option
                        v-for="item in feeTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计费标准" prop="feeAmt">
                <el-input-number v-model="dialogModel.feeAmt" :controls="false" controls-position="right" :precision="2" :step="0.1" @change="handleChange" :min="0" style="width: 91%"></el-input-number>
                <!--<el-input v-model="dialogModel.feeAmt" placeholder="请输入计费标准"></el-input>-->
                <span>{{dialogModel.feeType == 1 ? '%' : '元'}}</span>
            </el-form-item>
            <!--<el-form-item label="状态" prop="status">-->
            <!--<el-select v-model="dialogModel.status">-->
            <!--<el-option-->
            <!--v-for="item in status"-->
            <!--:key="item.value"-->
            <!--:label="item.label"-->
            <!--:value="item.value">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item label="描述" prop="remark">
                <el-input maxlength="80" show-word-limit v-model="dialogModel.remark" type="textarea" resize="none"></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FormDialog from '../../dialog/FormDialog'
    import ElInput from "element-ui/packages/input/src/input";

    import OrganService from 'service/OrganService'
    import OrganAuthService from 'service/OrganAuthService'
    import ChannelService from 'service/ChannelService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "organcertification",
        data(){
            return{
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                chnNameList: [],
                states:[],
                formModel:{
                    tatSimpleId:'',
                },
                dialogModel:{
                    tatSimpleId:'',
                    chnId:'',
                    feeType:'',
                    feeAmt:'',
                    tradingType:'',
                    remark:''
                },
                tableData:[],
                tradingTypes:[{
                    value:'1',
                    label:'储蓄卡'
                },{
                    value:'2',
                    label:'信用卡'
                },],
                formDialogTitle:'',
                submitService:OrganAuthService.list,
                params:{},
                authId:'',
                dialogRules: {
                    tatSimpleId: [{
                        required: true,
                        message: '请选择机构简称'
                        // validator: (rule, value, callback) => {
                        //     if (!value) {
                        //         callback(new Error('请选择机构简称'))
                        //     } else{
                        //         if (this.getTatSimpleId == value){
                        //             return callback();
                        //         }
                        //         this.checkOnly(value,res =>{
                        //             res.contents.checkFlag ? callback(new Error('机构简称不能重复')) : callback()
                        //         });
                        //     }
                        // },
                    }],
                    tradingType: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请选择交易类型'))
                            } else{
                                if (this.getTradingType == value){
                                    return callback();
                                }
                                this.checkTraOnly(this.dialogModel.tatSimpleId, value, this.authId,res =>{
                                    res.contents.checkFlag ? callback(new Error('同一机构下交易类型不能重复')) : callback()
                                });
                            }
                        },
                    }],
                    feeAmt: [{
                        required: true,
                        message: '请输入收费标准'
                    }],
                    chnId:[{
                        required:true,
                        message: '请选择通道名称'
                    }],
                },
                checkFlag:false,
                getTatSimpleId:'',
                getTradingType:'',
                page: {},
                isPage: false,
            }
        },
        components:{
            ElInput,
            CommonTopForm ,
            CommonTable,
            SelectOrgans,
            FormDialog
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed:{
            submitData(){
                this.params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    userId: this.userId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogService() {
                if (this.authId) {
                    return OrganAuthService.update;
                } else {
                    return OrganAuthService.add;
                }
            },
            dialogData() {
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                    chnId: this.dialogModel.chnId,
                    feeAmt: this.dialogModel.feeAmt,
                    remark: this.dialogModel.remark,
                    tradingType: this.dialogModel.tradingType,
                    userId: this.userId,
                };
                if (this.authId) {
                    params.id = this.authId;
                }
                if (this.dialogModel.remark == '' ||this.dialogModel.remark == undefined) {
                    delete params.remark;
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted(){
            this.page = this.$refs.commonTable.page;
            this.getList();
            this.getTypeNames('feeType', (res) => {
                this.feeTypes = res;
            });
        },
        methods:{
            handleChange(e){

            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getchnNameList(){
                this.doLoad(OrganAuthService.getShortNames,'', res => {
                    this.doCheck(res, res => {
                        this.chnNameList = res.contents;
                    });
                }, '信息获取失败')
            },
            getList() {
                this.doLoad(OrganAuthService.list, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;

                    });
                }, '信息获取失败')
            },
            addInfo(){
                this.formDialogTitle = '添加实名认证';
                this.$refs.formDialog.open();
            },
            updateInfo(id){
                this.authId = id;
                this.getDetail();
                this.formDialogTitle = '修改实名认证';
                this.$refs.formDialog.open();
            },
            onSuccess(data){
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                })
            },
            doDisabled(id) {
                const disabledParams = {
                    id: id,
                    userId: this.userId,
                    status: this.status,
                };
                this.doLoad(OrganAuthService.dpstatus, disabledParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            Disabled(id, type) {
                if (type == 0) {
                    this.status = 1;
                    this.showMsg = '确定启用此机构实名？'
                } else if (type == 1) {
                    this.status = 0;
                    this.showMsg = '确定禁用此机构实名？'
                }
                this.showConfirm(this.showMsg).then(() => {
                    this.doDisabled(id)
                }).catch(() => {
                });
            },
            doDeleteInfo(id) {
                const disabledParams = {
                    id: id,
                };
                this.doLoad(OrganAuthService.delInfo, disabledParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            DeleteInfo(id) {
                this.showMsg = '确定删除此机构实名？'
                this.showConfirm(this.showMsg).then(() => {
                    this.doDeleteInfo(id)
                }).catch(() => {
                });
            },
            getDetail() {
                const params = {
                    id: this.authId,
                    userId: this.userId,
                };

                this.doLoad(OrganAuthService.detail, params, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.dialogModel = result;
                        this.getTatSimpleId = this.dialogModel.tatSimpleId;
                        this.getTradingType = this.dialogModel.tradingType;
                        this.dialogModel.feeAmt = this.dialogModel.feeAmt *100 / 10000;
                        this.dialogModel.feeType = this.dialogModel.feeType.toString();
                        this.dialogModel.status = this.dialogModel.status.toString();
                        this.dialogModel.tradingType = this.dialogModel.tradingType.toString();
                    });
                }, '信息获取失败')
            },
            dialogSuccess(res) {
                this.doCheck(res, res => {
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                })
            },
            dialogClose() {
                this.dialogModel = {
                    tatSimpleId:'',
                    chnId:'',
                    feeAmt:'',
                    feeType:'',
                    tradingType:'',
                    remark:''
                };
                this.authId = '';
            },
            dialogOpen() {
                this.getchnNameList();
                if (this.authId) {
                    this.getDetail();
                }
            },
            checkOnly(val,onSuccess){
                const params = {
                    tatSimpleId:val,
                };
                this.doLoad(OrganAuthService.isExist,params,res => {
                    this.doCheck(res,res =>{
                        onSuccess && onSuccess(res);
                    });
                },'信息获取失败')
            },
            checkTraOnly(tatSimpleId,tradingType, id, onSuccess){
                const params = {
                    tatSimpleId:tatSimpleId,
                    tradingType:tradingType,
                    id:id
                };
                this.doLoad(OrganAuthService.isExistTatAndTradingType,params,res => {
                    this.doCheck(res,res =>{
                        onSuccess && onSuccess(res);
                    });
                },'信息获取失败')
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganCertification.vue